import React, { useContext } from 'react';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import { ucwords } from '../helper';
import CmsContext from '../../../../context/CmsContext';

function BusinessInformation({ data, handleAddRemarks, isLoading, remarks, handleAddApprovalNotes }) {
  const cmsContext = useContext(CmsContext);
  const CMS_VARIABLES = cmsContext.findByType('VARIABLES');

  const details = get(data, 'attributes.details') || {};
  const permissions = getJson('permissions');

  const createMarkup = remarksData => {
    return { __html: remarksData };
  };

  return (
    <div className="p-3">
      <table className="transaction-table table table-borderless table-sm">
        <tbody>
          <tr>
            <td className="text-dark" width="250">
              BIN
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.bin') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              TIN Number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.tin_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              SEC Number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.sec_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              DTI Number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.dti_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Kind
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.kind_of_ownership') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Business Name
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.business_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Owners Name
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.owners_display_name')}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Cellphone Number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.cellphone_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Telephone Number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.telephone_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Address
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>
                {get(data, 'attributes.main_office_display_address') || '-'}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Zip Code
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.zip_code') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Area
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.area') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Base Line
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.base_line') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              CDA
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.cda_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              DTI
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.dti_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Email
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.email_address') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Activity Type
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.activity_type') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Lessor Name
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.lessor_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Monthly Rental
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.monthly_rental') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Nationality
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.nationality') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              No. of Employees
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.no_of_employees') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              {`No. of Employees Residing ${get(CMS_VARIABLES, "LGU_NAME")}`}
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>
                {get(data, 'attributes.no_of_employees_residing_manila') || '-'}
              </b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              No. of Female Employees
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.no_of_female_employees') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              No. of Male Employees
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.no_of_male_employees') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              No. of Motorcycle
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.no_of_motorcycle') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              No. of Truck
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.no_of_truck') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              No. of Van
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.no_of_van') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              No. of Vehicles
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.no_of_vehicles') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              SEC
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.sec_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              TDN
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.tdn_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              PIN
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.pin_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Tax Identification Number
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.tin_no') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Gross Amount
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.gross_amount') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Trade Name
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.trade_name') || '-'}</b>
            </td>
          </tr>
          <tr>
            <td className="text-dark" width="250">
              Veterinary Fee
            </td>
            <td className="text-dark" width="1">
              :
            </td>
            <td colSpan={4}>
              <b>{get(data, 'attributes.veterinary_fee_name') || '-'}</b>
            </td>
          </tr>
          {Object.entries(details).map(item => {
            return (
              <tr key={`bpls_business_detail${item[0]}`}>
                <td className="text-dark" width="250">
                  {ucwords(item[0].replace(/_/g, ' '))}
                </td>
                <td className="text-dark" width="1">
                  :
                </td>
                <td colSpan={4}>
                  <b>{item[1] || '-'}</b>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <table className="w-100 transaction-table table table-borderless table-sm table-striped table-hover">
        <tbody>
          <tr />
          <tr className="">
            <td className="text-success" colSpan={3}>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <b>Approval Notes</b>
                {['FOR LICENSE ASSESSMENT'].indexOf(
                  get(remarks, 'included.bplsApplication.attributes.status')
                ) === -1 &&
                  ['NEW'].indexOf(
                    get(remarks, 'attributes.transaction_type')
                  ) > -1 &&
                  Acl(permissions, ['E2E BPLS UPDATE APPROVAL NOTES']) && (
                    <button
                      // disabled={get(
                      //   remarks,
                      //   'included.bplsApplication.attributes.approval_notes'
                      // )}
                      type="button"
                      onClick={handleAddApprovalNotes(remarks)}
                      className="btn btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
                    >
                      {isLoading ? (
                        <i className="fa fa-spin fa-spinner" />
                      ) : (
                        'Add Approval Notes'
                      )}
                    </button>
                  )}
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={5}>
              <div className="w-100 my-2 p-2">
                <b className="text-wrap text-break">
                  {get(
                    remarks,
                    'included.bplsApplication.attributes.approval_notes'
                  ) || '--'}
                </b>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <hr className="ct-hr" />
      <table className="w-100 transaction-table table table-borderless table-sm table-striped table-hover">
        <tbody>
          <tr />
          <tr className="">
            <td className="text-success" colSpan={3}>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <b>REMARKS</b>
                {['NEW', 'RENEWAL', 'CHANGE'].indexOf(
                  get(remarks, 'attributes.transaction_type')
                ) > -1 &&
                  Acl(permissions, ['E2E BPLS REMARKS']) && (
                    <button
                      disabled={isLoading}
                      type="button"
                      onClick={handleAddRemarks(remarks)}
                      className="btn btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold"
                    >
                      {isLoading ? (
                        <i className="fa fa-spin fa-spinner" />
                      ) : (
                        <>
                          {get(
                            remarks,
                            'included.bplsApplication.attributes.remarks'
                          )
                            ? 'Edit Remarks'
                            : 'Add Remarks'}
                        </>
                      )}
                    </button>
                  )}
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={5}>
              <div className="w-100 my-2 p-2">
                <div
                  // eslint-disable-next-line
                  dangerouslySetInnerHTML={createMarkup(get(
                    remarks,
                    'included.bplsApplication.attributes.remarks'
                  ) || '--')}
                />
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
  );
}

BusinessInformation.defaultProps = {
  data: {},
};

BusinessInformation.propTypes = {
  data: PropTypes.instanceOf(Object),
  handleAddRemarks: PropTypes.instanceOf(Function).isRequired,
  handleAddApprovalNotes: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  remarks: PropTypes.instanceOf(Object).isRequired,
};

export default BusinessInformation;
